import {resolutions, kijs, wmsServiceHost, vectorTilesBaseURL} from '../config';
import TileLayer from 'ol/layer/Tile.js';
import TileWMS from 'ol/source/TileWMS.js';
import TileGrid from 'ol/tilegrid/TileGrid';
import TileState from 'ol/TileState';
//import tileLoadFunction from './tileLoadFunction';

let ALREADY_FETCHING_NEW_KEY = false;

const tileLoadFunction = (imageTile, src) => {
    src = src.replace('<KIJSPLACEHOLDER>',kijs);
	var xhr = new XMLHttpRequest();
	xhr.responseType = 'blob';
	xhr.addEventListener('loadend', function(evt) {
		var data = this.response;

		if (data !== undefined) {
            data.text().then(res => {
                if (res == 'bad kijs' && !ALREADY_FETCHING_NEW_KEY) {
					ALREADY_FETCHING_NEW_KEY = true;
                    fetch('/backend/public/v1/key')
                    .then(resp => resp.json())
                    .then(res => {
					//	kijs = res.key;
					//	ALREADY_FETCHING_NEW_KEY = false;
                    })
                }
            });
			imageTile.getImage().src = URL.createObjectURL(data);
		} else {
			imageTile.setState(TileState.ERROR);
		}
	});
	xhr.addEventListener('error', function() {
		imageTile.setState(TileState.ERROR);
	});
	xhr.open('GET', src);
	xhr.send();
};


export const wmsLayer = new TileLayer({
	title: "KIJS",
	source: new TileWMS({
		url: wmsServiceHost + '/'+kijs+'/wgs/15/',
		params: {LAYERS: '0', VERSION: '1.1.1'},
		tileGrid: new TileGrid({
			origin: [-20037508.342787001, -20037508.342787001],
			resolutions: resolutions
		}),
		//tileLoadFunction: tileLoadFunction
	})
});

export var wmsBWLayer = new TileLayer({
	title: "KIJS",
//	saturation:0.6,
//	hue:-1.0,
	source: new TileWMS({
		url: wmsServiceHost + '/'+kijs+'/wgs/15bw/',
		params: {LAYERS: '0', VERSION: '1.1.1'},
		tileGrid: new TileGrid({
			origin: [-20037508.342787001, -20037508.342787001],
			resolutions: resolutions
		}),
		//tileLoadFunction: tileLoadFunction
	})
});

/* Pamat līmenis ar FOTO karti */
export var photoLayer = new TileLayer({
		title: "KIJS Photo",
		visible: true,
		preload: 'Infinity',
		//extent: [2274765.961767, 7509173.658736, 3188341.323831, 7987363.707688],
		source: new TileWMS({
		  url: wmsServiceHost + '/'+kijs+'/wgs/orto_full/',
		  params: {LAYERS: '0', VERSION: '1.1.1'},
		  tileGrid: new TileGrid({
			  origin: [-20037508.342787001, -20037508.342787001],
			  resolutions: resolutions
		  }),
		  //tileLoadFunction: tileLoadFunction
		})
	});



	/* Pamat līmenis ar igauņu ortofoto */
	export var eestiPhotoLayer = new TileLayer({
		title: "Estonian Photo",
		visible: true,
		preload: 'Infinity',
		extent: [2316347.705154, 7889524.311483, 3262943.863438, 8425195.005705],
		source: new TileWMS({
		  url: 'https://kaart.maaamet.ee/wms/alus-geo',
		  projection: 'EPSG:4326',
		  crossOrigin: 'anonymous',
		  params: {LAYERS: 'EESTIFOTO', VERSION: '1.3.0'},
		})
	});

	/* Pamat līmenis ar igauņu ortofoto */
	export var bbsSatelite = new TileLayer({
		title: "BBS Satelite",
		visible: true,
		preload: 'Infinity',
		source: new TileWMS({
		  url: wmsServiceHost + '/' + kijs + '/wgs/forestradar_optical/',
		  resolutions: resolutions
		})
	});

/* Pamat līmenis ar TOPO karti */
export var topoLayer = new TileLayer({
		title: "KIJS Topo",
		visible: true,
		preload: 'Infinity',
		source: new TileWMS({
		  url: wmsServiceHost + '/'+kijs+'/wgs/topo/',
		  params: {LAYERS: '0', VERSION: '1.1.1'},
		  tileGrid: new TileGrid({
			  origin: [-20037508.342787001, -20037508.342787001],
			  resolutions: resolutions
		  }),
		  //tileLoadFunction: tileLoadFunction
		})
});

/* Pamat līmenis ar TOPO vēsturisko karti */
export var topo75Layer = new TileLayer({
	title: "Topo 75",
	visible: true,
	preload: 'Infinity',
	source: new TileWMS({
		url: wmsServiceHost + '/'+kijs+'/wgs/topo_old/',
		params: {LAYERS: '0', VERSION: '1.1.1'},
		tileGrid: new TileGrid({
			origin: [-20037508.342787001, -20037508.342787001],
			resolutions: resolutions
		}),
		//tileLoadFunction: tileLoadFunction
	})
});

export const lidarLayer = new TileLayer({
	title: "KIJS",
	source: new TileWMS({
		url: wmsServiceHost + '/'+kijs+'/wgs/lidar/',
		params: {LAYERS: '0', VERSION: '1.1.1'},
		tileGrid: new TileGrid({
			origin: [-20037508.342787001, -20037508.342787001],
			resolutions: resolutions
		}),
		//tileLoadFunction: tileLoadFunction
	})
});

/* Pamat līmenis ar TOPO karti */
export var blankLayer = new TileLayer();
/* Openlayers vectory layers implementation: disabled for now (using mapbox )*/

/*
const vectorLayerWrapper = layerName => (new VectorTileLayer({
	declutter: true,
	preload: 'Infinity',
	maxZoom: 16,
	renderMode: 'vector',
	zIndex: layerName == 'baltic_labels' ? 5 : 4,//drawing layer zIndex is '6'
	title: layerName,//for debugging
	visible: true,
	source: new VectorTileSource({
		attributions: '',
		format: new MVT(),
		url: wmsServiceHost + '/' + kijs + '/wgs/'+layerName+'/{z}/{x}/{y}',
		  crossOrigin: null,
		  maxZoom: 16
	})
}));

export const vectorLayer = vectorLayerWrapper('baltic_basemap');
export const vectorLayerLabels = vectorLayerWrapper('baltic_labels');

fetch(vectorTilesBaseURL+'/styles/baltic-vt.php?key='+kijs)
  .then(r => r.json())
  .then((glStyle) => {
    stylefunction(vectorLayer, glStyle, 'esri');
    stylefunction(vectorLayerLabels, glStyle, 'esri_labels');
});
*/
